// /* eslint-disable jsx-a11y/anchor-is-valid */
import { enIN } from 'date-fns/locale';
import { Field, Formik, Form as FormikForm } from 'formik';
import React, { useState } from 'react';
import { Button, Col, Dropdown, Form, Row } from 'react-bootstrap';
import { registerLocale } from 'react-datepicker';
import { DateFormatNew } from '../../../../constants/date-picker-constant';
import { HKRScheduleFilterInitialState } from '../../../../core/initialState/filter-initial-state';
import { IHKRSchdeuleFilter } from '../../../../models/IHKRScheduleFilter';
import FormikFormDatePicker from '../../../../shared-components/FormikFormHandlers/FormikFormDatePicker';
import { DashboardFilterValidationSchema } from '../../../../shared-components/FormikFormHandlers/FormikValidationSchema';
import FormikFormInput from '../../../../shared-components/FormikFormHandlers/FormikFormInput';
import FormLoader from '../../../../shared-components/FormLoader/FormLoader';
import Label from '../../../../shared-components/label/label';
import {
  ClearFilterIcon,
  FilterIcon,
} from '../../../../shared-components/svgs/svgs';
import { formatMessage } from '../../../../translations/format-message';
import validCharacters from '../../../../constants/valid-characters';

registerLocale('en-IN', enIN);

interface IProps {
  initialValues: IHKRSchdeuleFilter;
  id: number;
  submitHandler: (data: any) => void;
  filterParmas: (data: any, isfilterCleard: boolean) => void;
  onModalClosed: () => void;
  isLoading: boolean;
  isDisable?: boolean;
  isFilterCleared: boolean;
  isFilterApplied: boolean;
  setIsFilterApplied: (status: boolean) => void;
}
const FilterComponent = (props: IProps) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const handleToggle = (isOpen: boolean, resetForm: () => void) => {
    if (!isOpen) {
      resetForm();
    }
    setShowDropdown(isOpen);
  };

  const getddMMyyDateFormat = (input: string): string => {
    const date = new Date(input);

    return (
      String(date.getFullYear()) +
      '-' +
      String(date.getMonth() + 1).padStart(2, '0') +
      '-' +
      String(date.getDate()).padStart(2, '0')
    );
  };
  return (
    <React.Fragment>
      <Formik
        initialValues={props.initialValues}
        enableReinitialize
        validationSchema={DashboardFilterValidationSchema}
        validateOnBlur={false}
        onSubmit={async (
          values: IHKRSchdeuleFilter,
          { resetForm, setFieldValue }
        ) => {
          if (values.StartTime) {
            values = {
              ...values,
              StartTime: getddMMyyDateFormat(values.StartTime),
            };
          }

          if (values.EndTime) {
            values = {
              ...values,
              EndTime: getddMMyyDateFormat(values.EndTime),
            };
          }
          props.submitHandler(values);
          setShowDropdown(false);
          props.setIsFilterApplied(true);
        }}
      >
        {({ dirty, resetForm, setFieldValue, values }) => {
          return (
            <Dropdown
              className={`Filter-DID filter-hkr ${props.isDisable ? 'disabled-li' : ''}`}
              show={showDropdown}
              onToggle={(isOpen) => handleToggle(isOpen, resetForm)}
            >
              <Dropdown.Toggle
                className={`btn btn-light ${props.isFilterApplied ? 'btn-filter-disable' : 'btn-filter'}`}
                aria-expanded="false"
                title={formatMessage('filter')}
              >
                {/* <FilterIcon isDisable={props.isDisable} /> */}
                {!props.isFilterApplied ? (
                  <FilterIcon isDisable={props.isDisable} />
                ) : (
                  <ClearFilterIcon
                    onClick={(e) => {
                      // props.filterParmas(
                      //   { ...HKRScheduleFilterInitialState },
                      //   true
                      // );
                      resetForm();
                      setShowDropdown(!showDropdown);
                      // props.setIsFilterApplied(!props.isFilterApplied);
                    }}
                  />
                )}
              </Dropdown.Toggle>
              <FormikForm className="user-form">
                {props.isLoading ? (
                  <FormLoader loading={props.isLoading} />
                ) : null}
                <Dropdown.Menu className="filter-menu">
                  <Dropdown.ItemText className="p-0">
                    <Form.Group controlId="dateRange">
                      <div
                        className={`filter-header border-bottom p-3 px-4 ${props.isFilterCleared ? '' : ''}`}
                      >
                        <h4>
                          {formatMessage('filter')}
                          <a
                            className="clear-filter float-end"
                            onClick={() => {
                              resetForm();
                              setShowDropdown(false);
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              fill="currentColor"
                              className="bi bi-x"
                              viewBox="0 0 16 16"
                            >
                              <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"></path>
                            </svg>
                          </a>
                        </h4>
                      </div>
                      <Row className="p-3 px-4">
                        <Col md={6}>
                          <div className="form-group">
                            <Label
                              className="label-style  col-form-label"
                              required={false}
                              label="kishu"
                              htmlFor="Kishu"
                            />
                            <Field
                              data-testid="Kishu"
                              className="form-control"
                              name="Kishu"
                              autoComplete="off"
                              placeholder=""
                              as={FormikFormInput}
                              validcharacter={validCharacters}
                            />
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="form-group">
                            <Label
                              className="label-style  col-form-label"
                              required={false}
                              label="code"
                              htmlFor="Code"
                            />
                            <Field
                              data-testid="Code"
                              className="form-control"
                              name="Code"
                              autoComplete="off"
                              placeholder=""
                              as={FormikFormInput}
                            />
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="form-group mb-0">
                            <Label
                              className="label-style col-form-label"
                              required={false}
                              label="start_date"
                              htmlFor="StartTime"
                            />
                            <Field
                              data-testid="StartTime"
                              className="form-control"
                              name="StartTime"
                              autoComplete="off"
                              placeholder=""
                              // as={FormikFormInput}
                              // dateFormat={DateFormatForDatePickerJP}
                              dateFormat={DateFormatNew}
                              // minDate={subDays(new Date(), 0)}
                              showOutsideDays={false}
                              as={FormikFormDatePicker}
                              isClearable={values.StartTime}
                              fixedHeight
                              maxDate={values.EndTime ? new Date(values.EndTime) : undefined}
                            />
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="form-group mb-0">
                            <Label
                              className="label-style col-form-label"
                              required={false}
                              label="end_date"
                              htmlFor="EndTime"
                            />
                            <Field
                              data-testid="EndTime"
                              className="form-control"
                              name="EndTime"
                              autoComplete="off"
                              type="text"
                              placeholder=""
                              dateFormat={DateFormatNew}
                              showOutsideDays={false}
                              as={FormikFormDatePicker}
                              fixedHeight
                              isClearable={values.EndTime}
                              minDate={values.StartTime ? new Date(values.StartTime) : undefined}
                            />
                          </div>
                        </Col>
                      </Row>
                    </Form.Group>
                  </Dropdown.ItemText>
                  <Dropdown.Divider className="mb-0" />
                  <div className="d-flex filter-btn p-3 px-4 justify-content-between align-items-center">
                  <div style={{ visibility: props.isFilterCleared ? 'hidden' : 'visible' }}>
                      <Button
                        className="clear-filter float-end"
                        onClick={() => {
                          props.filterParmas(
                            HKRScheduleFilterInitialState,
                            true
                          );
                          resetForm();
                          setShowDropdown(false);
                          props.setIsFilterApplied(false);
                        }}
                      >
                        {formatMessage('clear_all_filters')}
                      </Button>
                    </div>
                    <Button
                      variant="secondary"
                      type="submit"
                      className=""
                      disabled={(JSON.stringify(props.initialValues) === JSON.stringify(values)) || (!values.Kishu && !values.Code && !values.StartTime && !values.EndTime)}
                    >
                      {formatMessage('apply')}
                    </Button>
                  </div>
                </Dropdown.Menu>
              </FormikForm>
            </Dropdown>
          );
        }}
      </Formik>
    </React.Fragment>
  );
};

export default FilterComponent;
